export function jwtCheck() {
  let user;

  try {
    user = JSON.parse(localStorage.getItem('cdmin_user'));
  } catch (error) {
    user = null;
  }
  if (user && user.token) {
    return user.token;
  } else {
    return false;
  }
}

export const setToken = (accessToken, refreshToken, role) => {
  localStorage.setItem('cdmin_user', JSON.stringify(accessToken));
  localStorage.setItem('cdmin_userRefresh', JSON.stringify(refreshToken));
  localStorage.setItem('cdmin_role', JSON.stringify(role));
};
